import useCurrentVehicleStore from "../stores/InventoryStore";
import { useFromUser } from "../stores/LocalStorageHelper";
import { convertFromReactSelect } from "../features/inventory/subFeatures/selector/helperFunction/SelectorFormat.js";
import shallow from "zustand/shallow";
import { version } from "../version";
// BuildInventoryOBJ
export const useBuildVehicle = () => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	// Vehicle Store Values
	const vehicleObj = useCurrentVehicleStore((state) => state, shallow);
	const vehicle = {
		...vehicleObj,
		optionalEquip: convertFromReactSelect(vehicleObj.optionalEquip),
		dealerID,
		locationID,
		askingPrice: parseFloat(vehicleObj.askingPrice),
		pack: parseFloat(vehicleObj.pack),
		cost: parseFloat(vehicleObj.cost),
		notes: Array.isArray(vehicleObj.notes)
			? JSON.stringify(vehicleObj.notes)
			: "[]",
		onlinePrice: parseFloat(vehicleObj.onlinePrice),
		wholesalePrice: parseFloat(vehicleObj.wholesalePrice),
		dCVersion: "v" + version,
		// for JSON deserialization issue
		mpgcity: vehicleObj.mPGCity,
		mpghwy: vehicleObj.mPGHwy,
	};

	const getVehicle = () => {
		console.log(vehicle);
		return vehicle;
	};
	return getVehicle;
};
export default useBuildVehicle;
